export const images = {
  methods: {
    imageAsBase64: img => {
      let reader = new FileReader()
      reader.readAsDataURL(img)

      return reader
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/images.js